var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"key"},[_vm._v("问题数:")]),_c('div',{staticClass:"val"},[_vm._v(_vm._s(_vm.statistics.num))])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"key"},[_vm._v("问题金额:")]),_c('div',{staticClass:"val"},[_vm._v(_vm._s(_vm.statistics.kin.toFixed(2)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }